import type { UserData } from '@/types/auth'
import type { ApplicationFilters } from '../types/application'

/** Type-ahead fires every 2nd character (Angular searchProperty/searchCompany). */
export function shouldRunTypeaheadSearch(searchText: string): boolean {
  return searchText.length % 2 === 0
}

/** Seed company/property ids for scoped roles (Angular getAccessiblePermission). */
export function getRoleScopedFilterLock(user: UserData | null): Partial<ApplicationFilters> {
  const lock: Partial<ApplicationFilters> = {}
  const companyId = user?.current_role?.company_id
  const propertyId = user?.current_role?.property_id
  if (companyId) lock.company_id = String(companyId)
  if (propertyId) lock.property_id = String(propertyId)
  return lock
}
